 
import React from 'react';
import { useTravel } from 'v3/pages/Travel';
import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';
import Text from 'v3/components/Text';
import { DataTable, Link } from 'v3/components';
import { formatDateTime } from 'utils/formatter';

export default function RelatedTravels() {
  const travel = useTravel();
  return (
    <>
      <Card
        loading={travel.isLoading}
        LoadingBodyComponent={() => <DefaultLoadingBodyComponent linesCount={5} perLine={2} />}
        header={
          <Text type="header" color="dark">
            Viagens Relacionadas
          </Text>
        }
      >
        <DataTable
          data={travel?.data?.travelRelated || []}
          loading={travel.isLoading}
          withFilterOption={false}
          withPagination={false}
          columns={[
            {
              name: 'Ação',
              selector: (row) => row?.type || 'Não infromado',
            },
            {
              name: 'N viagem',
              selector: (row) => (
                <Link to={`/viagens/${row?.relatedTravelId}`} target="_blank" withoutIcon>
                  <Text>{`${row?.relatedTravelId}`}</Text>
                </Link>
              ),
            },
            {
              name: 'Status atual',
              selector: (row) => row?.relatedTravel.travelStatus.name,
            },
            {
              name: 'Usuário da ação',
              selector: (row) => (
                <Link to={`/usuarios/${row?.createdBy}`} target="_blank" withoutIcon>
                  <Text>{`${row?.createdBy}`}</Text>
                </Link>
              ),
            },
            {
              name: 'Data / hora ação',
              selector: (row) =>
                row?.createdAt ? formatDateTime(row?.createdAt) : 'Não infromado',
            },
          ]}
        />
      </Card>
    </>
  );
}
